import { isNil } from 'lodash';

// Move this inside class
export const convertToArrayOfNumbers = (array) =>
  array.map((item) => (!isNil(item) ? Number(item) : item));

export const filterNullMonths = (dataItems) => {
  let filteredData = dataItems;
  if (Array.isArray(dataItems)) {
    filteredData = dataItems.filter((dataItem) => {
      const isValidMonth = !isNil(dataItem.trialMonth);
      return isValidMonth;
    });
  }
  return filteredData;
};
